import { __extends } from "tslib";
import { DescribeDeliveryStreamInput, DescribeDeliveryStreamOutput } from "../models/index";
import { deserializeAws_json1_1DescribeDeliveryStreamCommand, serializeAws_json1_1DescribeDeliveryStreamCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DescribeDeliveryStreamCommand = /** @class */ (function (_super) {
    __extends(DescribeDeliveryStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeDeliveryStreamCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DescribeDeliveryStreamCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DescribeDeliveryStreamInput.filterSensitiveLog,
            outputFilterSensitiveLog: DescribeDeliveryStreamOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeDeliveryStreamCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1DescribeDeliveryStreamCommand(input, context);
    };
    DescribeDeliveryStreamCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1DescribeDeliveryStreamCommand(output, context);
    };
    return DescribeDeliveryStreamCommand;
}($Command));
export { DescribeDeliveryStreamCommand };
//# sourceMappingURL=DescribeDeliveryStreamCommand.js.map